<kb-icon [icon]="iconMap[icon]"></kb-icon>
